import { Component, Input, SimpleChanges } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { TPVServices } from "../../../services";
import { ChangeDetectionStrategy } from "@angular/core";

/**
 * Generated class for the TpvTicketSelectedListTicketPrintPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

/**
 * tpvServices.ticket_print -> seleccionamos si normal o invidual
 *
 * NORMAL
 *-------
 * globals -> informacion del restaurante ademas del header y footer
 * tpvServices.tables_array.ticket -> informacion basica del ticket como la fecha
 * selected_list -> lista de platos menus... del ticket
 *
 * INV
 *-------
 * globals -> informacion del restaurante ademas del header y footer
 * tpvServices.ticket_print_ind_number y ticket_print_ind_date -> informacion basica del ticket
 * tpvServices.ticket_print_ind -> toda la informacion del ticket
 * tpvServices.subtotal_ticket_indv_print -> subtotal del ticket
 * tpvServices.total_ticket_indv_print -> total del ticket
 * */

@Component({
    changeDetection: ChangeDetectionStrategy.Default, //Sin esto no detecta el cambio del total y da un error
    selector: 'page-tpv-ticket-selected-list-ticket-print',
    templateUrl: 'tpv-ticket-selected-list-ticket-print.html',
})
export class TpvTicketSelectedListTicketPrintPage {
    @Input() selected_list: any;
    footer: any;
    header: any;
    list_tax: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public tpvServices: TPVServices) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.selected_list) {
            this.list_tax = this.globals.showIvaProducts(this.selected_list);
        }
    }

    calculateVariations(name, units, price, variation_add) {
        if (variation_add == undefined) {
            variation_add = 0;
        }
        return (parseFloat(units) * parseFloat(price)) + parseFloat(variation_add)
    }

}



// WEBPACK FOOTER //
// ./src/pages/tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-list-ticket-print/tpv-ticket-selected-list-ticket-print.ts